import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 48px);
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;
